import { browserHistory } from 'common/utils/browserHistory';
import { saveDashboardSortingConfiguration } from './userSortingHandler';

const invalidatePageCache = (dataArray) => {
  if (dataArray?.data) {
    dataArray.data.forEach((pageData) => {
      if (pageData) {
        // eslint-disable-next-line no-param-reassign
        pageData.time = 0;
      }
    });
  }
};

const findDataProps = (props) => {
  const dataProps = [];
  Object.keys(props).forEach((key) => {
    if (props[key]?.data && Array.isArray(props[key].data)) {
      dataProps.push(props[key]);
    }
  });
  return dataProps;
};

export const createSortChangeHandler = (component) => (column, direction) => {
  const { sidx, sord } = component.state;
  const newSord = direction || ((sidx === column && sord === 'asc') ? 'desc' : 'asc');

  const dataProps = findDataProps(component.props);
  dataProps.forEach(invalidatePageCache);

  const currentFolder = browserHistory.getCurrentLocation().pathname;
  const sortObj = {
    column,
    sortDirection: newSord,
  };

  component.setState({
    sidx: column,
    sord: newSord,
    page: 1,
  }, () => {
    saveDashboardSortingConfiguration(currentFolder, sortObj);
    component.fetch();
  });
};
